/* Syd's House - consolidated collection filter enhancements (Aug 2026 rebuild)
   Replaces syd-sort-filter.js AND the old inline block in theme.liquid.

   Hard rules learned from the Safari tab-kill bug:
   - NO MutationObservers. The old layer ran three of them (one on the whole
     body) and re-scanned the document on every mutation; iOS Safari killed
     the tab after a couple of rapid reloads. Re-runs are now driven by one
     wrapped call on FacetFiltersForm.renderProductGridContainer, which Dawn
     invokes exactly once after every AJAX filter re-render.
   - Price inputs and group toggles use event delegation bound ONCE to
     document. Nothing is rebound per render.
*/
(function () {
  'use strict';

  var ALLOWED_SORTS = ['manual', 'price-descending', 'price-ascending', 'created-descending', 'created-ascending'];
  var path = window.location.pathname.toLowerCase();
  var isLadies = path.indexOf('ladies') !== -1 || path.indexOf('women') !== -1;

  /* -- Sort dropdowns: Safari ignores display:none on <option>, so remove -- */
  function trimSortSelects() {
    var selects = document.querySelectorAll('#SortBy, #SortBy-mobile');
    Array.prototype.forEach.call(selects, function (select) {
      Array.prototype.slice.call(select.options).forEach(function (opt) {
        if (ALLOWED_SORTS.indexOf(opt.value) === -1) opt.parentNode.removeChild(opt);
      });
    });
  }

  /* -- Size filter helpers -- */
  function isNumericSize(val) { return /^\d+$/.test(val.trim()); }

  function getSizeFilterLabel(details) {
    var labelEl = details.querySelector('.facets__summary-label');
    if (labelEl) return labelEl.textContent.trim().toLowerCase();
    var summary = details.querySelector('summary');
    if (summary) {
      var span = summary.querySelector('div > span:first-child');
      if (span) return span.textContent.trim().toLowerCase();
    }
    return '';
  }

  function getListAndItems(details) {
    var list = details.querySelector('ul.facets__list');
    if (list) return { list: list, items: Array.prototype.slice.call(list.querySelectorAll('li.facets__item')) };
    list = details.querySelector('ul.mobile-facets__list');
    if (list) return { list: list, items: Array.prototype.slice.call(list.querySelectorAll('li.mobile-facets__item')) };
    return null;
  }

  function makeSubGroup(label, items) {
    var li = document.createElement('li');
    li.className = 'syd-size-group';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'syd-size-toggle facets__summary caption-large';
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span class="facets__summary-label">' + label + '</span><span class="syd-size-toggle__icon" aria-hidden="true">+</span>';
    var subList = document.createElement('ul');
    subList.className = 'syd-size-sublist';
    subList.setAttribute('hidden', '');
    items.forEach(function (item) { subList.appendChild(item); });
    li.appendChild(btn);
    li.appendChild(subList);
    return li;
  }

  function hideSizes() {
    if (isLadies) return;
    /* only numeric values inside the SIZE filter - availability etc. also use 0/1 */
    Array.prototype.forEach.call(document.querySelectorAll('details.js-filter'), function (details) {
      if (getSizeFilterLabel(details) !== 'size') return;
      var inputs = details.querySelectorAll('li.facets__item input[type="checkbox"], li.mobile-facets__item input[type="checkbox"]');
      Array.prototype.forEach.call(inputs, function (input) {
        var val = (input.value || '').trim();
        if (isNumericSize(val) && parseInt(val, 10) < 16) {
          var item = input.closest('li.facets__item') || input.closest('li.mobile-facets__item');
          if (item) item.style.display = 'none';
        }
      });
    });
  }

  function transformSizeFilters() {
    Array.prototype.forEach.call(document.querySelectorAll('details.js-filter'), function (details) {
      if (getSizeFilterLabel(details) !== 'size') return;
      var result = getListAndItems(details);
      if (!result || result.items.length === 0) return;
      if (result.list.querySelector('.syd-size-group')) return; /* already grouped */
      var tops = [], bottoms = [];
      result.items.forEach(function (item) {
        var input = item.querySelector('input[type="checkbox"]');
        if (!input) return;
        var val = (input.value || '').trim();
        if (isNumericSize(val)) bottoms.push(item);
        else tops.push(item);
      });
      if (tops.length === 0 || bottoms.length === 0) return;
      result.list.innerHTML = '';
      result.list.appendChild(makeSubGroup('Tops', tops));
      result.list.appendChild(makeSubGroup('Bottoms', bottoms));
    });
  }

  /* -- Price inputs: submit the form the inputs actually belong to -- */
  function applyPrice(input) {
    var container = input.closest('[data-price-facet]');
    if (!container) return;
    var displayMin = container.querySelector('[data-price-min-display]');
    var displayMax = container.querySelector('[data-price-max-display]');
    var hiddenMin = null, hiddenMax = null;
    var el = container.nextElementSibling;
    while (el) {
      if (el.tagName === 'INPUT' && el.type === 'hidden') {
        if (!hiddenMin) hiddenMin = el;
        else if (!hiddenMax) { hiddenMax = el; break; }
      }
      el = el.nextElementSibling;
    }
    if (!displayMin || !displayMax || !hiddenMin || !hiddenMax) return;
    hiddenMin.value = displayMin.value.replace(/[^0-9]/g, '');
    hiddenMax.value = displayMax.value.replace(/[^0-9]/g, '');
    if (typeof FacetFiltersForm === 'undefined') return;
    var form = container.closest('form') || document.getElementById('FacetFiltersForm');
    if (!form) return;
    var formData = new FormData(form);
    if (!formData.has('sort_by')) {
      var sortForm = document.getElementById('FacetSortDrawerForm');
      if (sortForm && sortForm !== form) {
        new FormData(sortForm).forEach(function (v, k) { if (k === 'sort_by') formData.append(k, v); });
      }
    }
    FacetFiltersForm.renderPage(new URLSearchParams(formData).toString(), null);
  }

  /* -- One-time delegated listeners (survive every re-render, never rebound) -- */
  function bindDelegatedOnce() {
    if (window.sydFacetsDelegated) return;
    window.sydFacetsDelegated = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.syd-size-toggle');
      if (!btn) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      var subList = btn.nextElementSibling;
      if (subList) {
        if (open) subList.setAttribute('hidden', '');
        else subList.removeAttribute('hidden');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var t = e.target;
      if (t && t.matches && (t.matches('[data-price-min-display]') || t.matches('[data-price-max-display]'))) {
        e.preventDefault();
        applyPrice(t);
      }
    });

    document.addEventListener('focusout', function (e) {
      var t = e.target;
      if (t && t.matches && (t.matches('[data-price-min-display]') || t.matches('[data-price-max-display]'))) {
        applyPrice(t);
      }
    });
  }

  function enhance() {
    trimSortSelects();
    hideSizes();
    transformSizeFilters();
  }

  /* -- Re-run after every AJAX filter render: wrap Dawn's grid renderer.
        Called once per render, AFTER renderFilters has swapped the facet DOM. -- */
  function hookRenders() {
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (typeof window.FacetFiltersForm !== 'undefined' && window.FacetFiltersForm.renderProductGridContainer) {
        clearInterval(timer);
        var orig = window.FacetFiltersForm.renderProductGridContainer;
        window.FacetFiltersForm.renderProductGridContainer = function (html) {
          var out = orig.call(this, html);
          try { enhance(); } catch (err) { /* never break Dawn's render */ }
          return out;
        };
      } else if (tries > 100) {
        clearInterval(timer);
      }
    }, 100);
  }

  function init() {
    bindDelegatedOnce();
    enhance();
    hookRenders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
